import React from 'react';
import './Blog.css';

const Blog = ({ articleTitle, articleComponent, id }) => {
    const email = localStorage.getItem('email');

    return (
        <div className="blog-container" id={id}>
            <div className="blog-content">
                <header className="blog-header">
                    <h1 className="blog-title">{articleTitle}</h1>
                    <div className="blog-author-section">
                        <p className="blog-author">By : {email}</p>
                        <div className="blog-author-line"></div>
                    </div>
                </header>
                {articleComponent.map((component, index) => (
                    <div key={index} className="blog-item">
                        {component.textAreaActive && <p className="blog-text">{component.text}</p>}
                        {!component.textAreaActive  &&
                            <img src={component.image} alt={`Image ${index}`} className="blog-image" style={{width:"40%" , height:"40%" , border:"1px solid black"}} />}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Blog;
